import { createRoot } from 'react-dom/client'
import 'tailwindcss'

import './index.css'
import Root from '@/Root'

import { init as initSentry } from './utils/sentry'

initSentry()

const container = document.getElementById('root') as HTMLDivElement
const root = createRoot(container)

root.render(<Root />)
